export default __webpack_public_path__ + "locales/de/ChangePortalOwner.json?hash=a504017a87ddfc8b2d40d3d8e176f7a7";